export default {"src":"/_next/static/media/calendar.dbc0f620.svg","height":23,"width":24};